export class CostType {
    id?: string;
    description!: string;
    glaccount_id?: number;
}
